export const EntityActionTypeSelectOptionValue = {
  Add: 'add',
  Edit: 'set',
  RemoveAll: 'clear',
}
